import { Link, useLocation } from 'react-router-dom';
import { InviteNotifications } from '@/components/notifications/InviteNotifications';

interface AppSidebarProps {
    isOpen: boolean;
    onClose: () => void;
}

export function AppSidebar({ isOpen, onClose }: AppSidebarProps) {
    const location = useLocation();

    const isActive = (path: string) => location.pathname === path;

    const navItems = [
        { name: 'Dashboard', path: '/', icon: 'bi-grid' },
        { name: 'My Playlists', path: '/playlists', icon: 'bi-collection-play' },
        { name: 'Live Sessions', path: '/live', icon: 'bi-broadcast' },
        { name: 'Profile', path: '/profile', icon: 'bi-person' },
    ];

    return (
        <>
            <div
                className={`app-sidebar bg-body border-end h-100 position-fixed start-0 top-0 bottom-0 overflow-auto pt-5 mt-5 d-md-block ${isOpen ? 'd-block shadow' : 'd-none'}`}
                style={{ width: '250px', zIndex: 1000, transition: 'transform 0.3s ease-in-out' }}
            >
                <ul className="nav nav-pills flex-column mb-auto p-2">
                    {navItems.map((item) => (
                        <li className="nav-item mb-1" key={item.path}>
                            <Link
                                to={item.path}
                                className={`nav-link ${isActive(item.path) ? 'active' : 'link-body-emphasis'} d-flex align-items-center`}
                                onClick={() => window.innerWidth < 768 && onClose()}
                            >
                                <i className={`bi ${item.icon} me-2 fs-5`}></i>
                                {item.name}
                            </Link>
                        </li>
                    ))}
                    <li className="nav-item mt-2 pt-2 border-top">
                        <InviteNotifications />
                    </li>
                </ul>
            </div>

            {/* Overlay for mobile */}
            {isOpen && (
                <div
                    className="d-md-none position-fixed top-0 start-0 w-100 h-100 bg-dark opacity-50"
                    style={{ zIndex: 999 }}
                    onClick={onClose}
                ></div>
            )}
        </>
    );
}
